"use client";

import { Hot } from "../Find/Hot";
import { ItemData } from "./types";
import { encodeString } from "@/src/utils/stringEncoder";

// 处理问题数据，根据 item 生成正确格式的 questionData
const handleQuestionData = (item: ItemData) => {
  return `symbol#${item.symbol}+id#${item.id}`;
};

interface ProjectGridProps {
  onItemClick?: ({
    keyword,
    token,
  }: {
    keyword?: string;
    token?: string;
  }) => void;
  data?: any[];
  loading?: boolean;
}

export const ProjectGrid = ({
  onItemClick,
  data,
  loading,
}: ProjectGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 sm:grid-cols-1 gap-4">
      {data?.map((item: any, index: number) => {
        const params = handleQuestionData({
          name: item?.project_name || "",
          address: item?.contract_address?.[0]?.address || "",
          symbol: item?.token_symbol || "",
          id: item?.contract_address?.[0]?.id || "",
        });
        return (
          <div
            data-openreplay-label="HomeQuestionCard · ProjectGrid · div"
            key={index}
            onClick={() => {
              onItemClick?.({
                keyword: `token_chat_${encodeString(`${params}`)}`,
                token: item.token_symbol,
              });
            }}
            className="bg-background_white_overlay5 hover:bg-background_white_overlay10 rounded-xl cursor-pointer"
          >
            <Hot data={item} />
          </div>
        );
      })}
      {loading &&
        data?.length === 0 &&
        Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className="flex gap-2 bg-background_white_overlay5 rounded-xl py-3 px-4 items-center min-w-60"
          >
            <div className="h-8 w-8 rounded-full bg-background_white_overlay10 animate-pulse" />
            <div className="flex flex-col gap-2">
              <div className="h-4 w-[73px] rounded-1 bg-background_white_overlay10 animate-pulse" />
              <div className="h-3 w-[53px] rounded-1 bg-background_white_overlay10 animate-pulse" />
            </div>
          </div>
        ))}
    </div>
  );
};
